module.exports = __webpack_public_path__ + "img/contact.309d3159.png";